import { useQuery } from "react-query";
import { getBaseUrl } from "../utils";

const useGetPasswordReset = ({ dispatch, email, queryConfig }: { dispatch: any, email: string, queryConfig: any }) => {
  const queryFn = () => fetch(`${getBaseUrl()
    }/api/auth/requestPasswordReset?emailAddress=${encodeURIComponent(
      email
    )}`, { method: 'GET' }).then(res => {
      if (!res.ok) {
        throw res
      }
      return res
    });

  return useQuery(
    ['fetchForgottenPass', email],
    queryFn,
    queryConfig
  );
}

export default useGetPasswordReset